import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {BringozLoaderService} from "./bringoz-loader.service";
import {ApiConfig} from "../models/api-config.model";
import {SplitService} from "./split-service.service";
import {ImportEntitiesAlertsService} from "./import-entities-alerts.service";

export class ImportEntitiesService {

  constructor(private apiConfig: ApiConfig, private splitService: SplitService, private Upload,
              private $http: IHttpService, private $q: IQService, private importEntitiesAlertsService: ImportEntitiesAlertsService, private bringozLoaderService: BringozLoaderService) {
  }

  getEntityImportPreview(path: string, file?: string, schemaId?: string) {
    const deferred = this.$q.defer();

    this.Upload.upload({
      url: this.apiConfig.baseUrl + `/${path}/importer/upload`,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        customSchemaId: schemaId,
        zoneId: this.splitService.getTimeZone()
      },
      data: {
        file: file
      }
    })
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((res) => {
        this.importEntitiesAlertsService.getEntityImportPreviewError()
        deferred.reject(res.error)
      })

    return deferred.promise
  }

  getEntityImportValidation(path: string, filePreview, schemaId?: string) {

    const deferred = this.$q.defer();

    this.$http({
      url: this.apiConfig.baseUrl + `/${path}/importer/validate`,
      method: 'POST',
      params: {
        siteId: this.splitService.getSiteId(),
        customSchemaId: schemaId,
        resolveSchema: true,
        zoneId: this.splitService.getTimeZone()
      },
      data: filePreview
    })
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((res) => {
        deferred.reject(res.error);
        this.importEntitiesAlertsService.getEntityImportValidationError()
      })

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.commons')
  .service('importEntitiesService', ImportEntitiesService);
